import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ChatbotService } from './shared/components/chatbot-widget/services/chatbot.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'kosmos-front-armonia';

  usuarioLogeado = true;
  mostrarPlantilla = false;
  esPortalCompras = false;
  tieneAccesoChatbot = false;

  constructor(
    private router: Router,
    private chatbotService: ChatbotService
  ) {
    const bandera = localStorage.getItem('mostrarMenu');
    if (bandera === 'true' ) {
        this.mostrarPlantilla = true;
    } else {
        this.mostrarPlantilla = false;
    }

    this.tieneAccesoChatbot = this.chatbotService.hasChatbotAccess();

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects || event.url;
        this.esPortalCompras = url.startsWith('/portal-compras');
        this.tieneAccesoChatbot = this.chatbotService.hasChatbotAccess();
      });
  }
}
